import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { changeLocale } from 'react-admin'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useUser } from './client'

const Login = ({ changeLanguage, history }) => {
  const { user } = useUser()

  useEffect(() => {
    if (user) {
      changeLanguage(user['https://gemsotec.com/language'] || 'en')
      history.push(sessionStorage.getItem('landingUrl') || '/users')
    }
  }, [user, changeLanguage, history])

  return null
}

Login.propTypes = {
  changeLanguage: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => ({
  changeLanguage: (code) => dispatch(changeLocale(code)),
})

export default withRouter(connect(undefined, mapDispatchToProps)(Login))
